/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { NavigationButton, NavigationButtonType } from "@octopusdeploy/design-system-components";
import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import ActionTemplateCard from "~/components/ActionTemplates/ActionTemplateCard";
import ActionTemplateCardList from "~/components/ActionTemplates/ActionTemplateCardList";
import filterActionTemplates from "~/components/ActionTemplates/filterActionTemplates";
import PageDivider from "~/components/PageDivider/PageDivider";
interface BuiltinActionTemplateListProps {
    templates: ActionTemplateSearchResource[];
    filter?: string;
    onPostSelectionUrlRequested?: (template: {
        Type: string;
        Id: string;
    } | string) => string;
}
class BuiltinActionTemplateList extends React.Component<BuiltinActionTemplateListProps, never> {
    render() {
        const filteredResults = filterActionTemplates(this.props.templates, this.props.filter!);
        if (filteredResults.length === 0 && this.props.filter) {
            return <p>There are no built-in step templates that match your filter criteria.</p>;
        }
        return (<div>
                <PageDivider>Built-in Step Templates</PageDivider>
                <ActionTemplateCardList>
                    {filteredResults.map((template) => {
                return (<ActionTemplateCard key={template.Type + template.Id} template={template} primaryAction={<NavigationButton label="Add" type={NavigationButtonType.Primary} href={this.props.onPostSelectionUrlRequested!(template)}/>} primaryRedirect={this.props.onPostSelectionUrlRequested!(template)}/>);
            })}
                </ActionTemplateCardList>
            </div>);
    }
    static displayName = "BuiltinActionTemplateList";
}
export default BuiltinActionTemplateList;
